export const actions = {
    'Cancel': 'Cancelar',
    'Create': 'Crear',
    'Disable': 'Deshabilitar',
    'Edit': 'Editar',
    'Enable': 'Habilitar',
    'Reload': 'Recargar',
    'Search': 'Buscar'
};
